export default {
    props: {
        columnMenuColumns: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.columns'
        }, 
        columnMenuFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.filterable'
        }, 
        columnMenuSortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.sortable'
        }, 
        columnMenuMessagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.columns'
        }, 
        columnMenuMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.filter'
        }, 
        columnMenuMessagesSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortAscending'
        }, 
        columnMenuMessagesSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortDescending'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/ColumnMenu.js